import {getEnvironment} from '@albert-io/environment';

export default {
  logLevel: process.env.NODE_ENV === 'development' ? 'debug' : 'error',
  releaseStage: getEnvironment(),
  appVersion: __VERSION,
  /**
   * Ensure various properties in payloads are filtered out to ensure PII does not make it's way to BugSnag.
   * @see https://docs.bugsnag.com/platforms/javascript/configuration-options/#filters
   */
  redactedKeys: [
    /^token$/i,
    /^email$/i,
    /^username$/i,
    /^password$/i,
    /^verify_?old_?password$/i,
    /^password_?reset_?link$/i,
    /^verify_?password_?reset_?link$/i,
    /^stripe_?customer_?id$/i,
    /^first_?name$/i,
    /^last_?name$/i,
    /^salutation$/i,
    /^consent_?email$/i
  ]
};
